export const configEndpoints = {
  updateWorkflow: { method: 'post', path: '/workflows/{id}/update' },
  validateWorkflow: { method: 'post', path: '/workflows/{id}/validate' },
  listOrgIntegrations: { method: 'get', path: '/integrations' },
  getOrgIntegration: { method: 'get', path: '/integrations/{id}' },
  createOrgIntegration: { method: 'post', path: '/integrations' },
  deleteOrgIntegration: { method: 'post', path: '/integrations/{id}/delete' },
  listOrgIntegrationOperations: { method: 'get', path: '/integration/operations' },
  getOrgIntegrationOperation: { method: 'get', path: '/integration/operations/{id}' },
  createOrgIntegrationOperation: { method: 'post', path: '/integration/operations' },
  deleteOrgIntegrationOperation: { method: 'post', path: '/integration/operations/{id}/delete' },
  createLinkedAccount: { method: 'post', path: '/integrations/{id}/link-account' },
  updateIntegrationAuth: { method: 'post', path: '/integrations/{id}/auth' },
  validateIntegrationAuth: { method: 'post', path: '/integrations/{id}/auth/validate' },
  getOrgIntegrationConfig: { method: 'get', path: '/integrations/{id}/config' },
  getSupportedExternalEntities: { method: 'get', path: '/integrations/{id}/entities/supported' },
  getSupportedExternalEntityFields: { method: 'get', path: '/integrations/{id}/entity-fields/{entityType}/supported' },
  addExternalEntity: { method: 'post', path: '/integrations/{id}/entities' },
  updateExternalEntity: { method: 'post', path: '/integrations/{id}/entities/{entityId}' },
  deleteExternalEntity: { method: 'post', path: '/integrations/{id}/entities/{entityId}/delete' },
  updateConfiguration: { method: 'post', path: '/integrations/{id}/configuration/update' },
  updateFilteringRules: { method: 'post', path: '/integrations/filtering-rules/update' },
  updatePollingSettings: { method: 'post', path: '/integrations/{id}/polling-settings' },
  updateDefaultSupplierState: { method: 'post', path: '/integrations/{id}/default-supplier-state' },
  updateFinancialDimensions: { method: 'post', path: '/integrations/{id}/financial-dimensions' },
  addOrgIntegrationCustomField: { method: 'post', path: '/integrations/{id}/customField' },
  updateOrgIntegrationCustomField: { method: 'post', path: '/integrations/{id}/customField/update' },
  deleteOrgIntegrationCustomField: { method: 'post', path: '/integrations/{id}/customField/delete' },
  listCoreDataOrganisationIntegrations: { method: 'get', path: '/integrations/core-data-organisation-integrations' },
  getConfigTranslations: { method: 'get', path: '/translations' },
  initConfigTranslationUpload: { method: 'post', path: '/translations/import/init' },
  acceptConfigTranslationsUpload: { method: 'post', path: '/translations/import/upload' },
} as const
